import Script from "next/script";
import React from "react";
import { env } from "~/env.mjs";

// // // //

const SNITCHER_PROFILE_ID = env.NEXT_PUBLIC_SNITCHER_PROFILE_ID;

/**
 * SnitcherScript
 * Loads Snitcher visitor identification tracking script
 */
export function SnitcherScript() {
    if (!SNITCHER_PROFILE_ID) {
        return null;
    }

    return (
        <Script id="snitcher" strategy="afterInteractive">
            {`!function(e){"use strict";var a=e&&e.namespace;if(a&&e.profileId&&e.cdn){var r=window[a];if(r&&Array.isArray(r)||(r=window[a]=[]),!r.initialized&&!r._loaded)if(r._loaded)console&&console.warn("[Radar] Duplicate initialization attempted");else{r._loaded=!0;["track","page","identify","group","alias","ready","debug","on","off","once","trackClick","trackSubmit","trackLink","trackForm","pageview","screen","reset","register","setAnonymousId","addSourceMiddleware","addIntegrationMiddleware","addDestinationMiddleware"].forEach((function(e){var i;r[e]=(i=e,function(){var e=window[a];if(e.initialized)return e[i].apply(e,arguments);var r=[].slice.call(arguments);return r.unshift(i),e.push(r),e})})),r.bootstrap=function(){var a=document.createElement("script");a.async=!0,a.type="text/javascript",a.id="__radar__",a.dataset.settings=JSON.stringify(e),a.src="https://"+e.cdn+"/releases/latest/radar.min.js";var r=document.scripts[0];r.parentNode.insertBefore(a,r)},r.bootstrap()}}else"undefined"!=typeof console&&console.error("[Radar] Configuration incomplete")}({"cdn":"cdn.snitcher.com","apiEndpoint":"radar.snitcher.com","profileId":"${SNITCHER_PROFILE_ID}","namespace":"Monaco","waitForConsent":true});`}
        </Script>
    );
}
